var map = {
	"./arrabbiato.png": "c481",
	"./assonnato.png": "0615",
	"./bevendo.png": "569e",
	"./birthday_cake.png": "c0b2",
	"./demoralizzato.png": "bce9",
	"./distrutto.png": "6048",
	"./divertito.png": "d4a9",
	"./felice.png": "b858",
	"./festeggiando.png": "9ba2",
	"./fiero.png": "64d4",
	"./fortunato.png": "774d",
	"./giocando.png": "bc5e",
	"./guardando.png": "6dd2",
	"./infreddolito.png": "270a",
	"./ingolosito.png": "7c93",
	"./innamorato.png": "363f",
	"./malato.png": "eede",
	"./mangiando.png": "cabd",
	"./pensieroso.png": "36dd",
	"./raffreddato.png": "cac4",
	"./scoglionato.png": "919f",
	"./sconsolato.png": "2921",
	"./stufo.png": "aece",
	"./stupito.png": "7f68",
	"./triste.png": "298d",
	"./una merda.png": "cb3e",
	"./viaggiando.png": "1d06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8eef";